// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__112og","requiredAsterisk":"Info_requiredAsterisk__3z4dM"};